import vehicles from "./vehicles/store";
import users from "./users/store";
import notifications from "./notifications/store";
import agents from "./agent/store";
import assignCompany from "./assignCompany/store";
import companies from "./companies/store"
import vehicleValuation from "./vehicle-valuation/store"
import providers from "./providers/store"
import vehiclesProviderPrice from "./vehicles-provider-price/store";
import files from "./files/store";
export default {
  state: {},
  actions: {},
  mutations: {},
  modules: {
    vehicles,
    users,
    notifications,
    agents,
    assignCompany,
    companies,
    vehicleValuation,
    providers,
    vehiclesProviderPrice,
    files,
  },
};
